export const properties = [
    {
        id:1,
        imgURL:'https://s3-assets.propstory.com/news-and-opinions/wp-content/uploads/2015/09/a-JUBILEE-HILLS-HOUSE-640x468.jpg',
        price:3600,
        name:'Manokamna',
        address:'10, Mehrauli, Mumbai',
        beds:1,
        bathrooms:1,
        area:'7 x 6 sq. m',
        wishlist:true,
        popular:true,
        date:5,
        month:11,
        year:2021,
        location:'Mumbai',
        type:'Apartment',
    },
    {
        id:2,
        imgURL:'https://mldllifespacebucket01.s3.amazonaws.com/2018/11/boisar-overview.jpg',
        price:5800,
        name:'Ray White',
        address:'10, Mehrauli, Mumbai',
        beds:2,
        bathrooms:1,
        area:'9 x 8 sq. m',
        wishlist:false,
        popular:false,
        date:5,
        month:9,
        year:2022,
        location:'Mumbai',
        type:'Flat',
    },
    {
        id:3,
        imgURL:'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8cHJvcGVydHl8ZW58MHx8MHx8&auto=format&fit=crop&w=600&q=60',
        price:12400,
        name:'Oak Wood',
        address:'10, Mehrauli, Mumbai',
        beds:3,
        bathrooms:2,
        area:'7 x 7 sq. m',
        wishlist:false,
        popular:false,
        date:5,
        month:9,
        year:2022,
        location:'Mumbai',
        type:'Ranch',
    },
    {
        id:4,
        imgURL:'https://assets.architecturaldigest.in/photos/6008391a94ca758bb0ad102d/4:3/w_1024,h_768,c_limit/white-house-shroffleon-mumbai-featured-image-1366x768.jpg',
        price:11300,
        name:'Royal View',
        address:'10, Mehrauli, Delhi',
        beds:2,
        bathrooms:2,
        area:'8 x 8 sq. m',
        wishlist:false,
        popular:false,
        date:5,
        month:9,
        year:2022,
        location:'Delhi',
        type:'Apartment',
    },
    {
        id:5,
        imgURL:'https://teja10.kuikr.com/i6/20220928/1-BHK-420-Sq-ft-Apartment-for-Sale-in-Kalyan-West--Mumbai-ak_LWBP391155191-1664346589_gv.jpeg',
        price:2300,
        name:'Sunset Treasury',
        address:'10, Mehrauli, Delhi',
        beds:1,
        bathrooms:1,
        area:'5 x 6 sq. m',
        wishlist:true,
        popular:false,
        date:7,
        month:9,
        year:2022,
        location:'Delhi',
        type:'Flat',
    },
    {
        id:6,
        imgURL:'https://gos3.ibcdn.com/e800fba692e511eba30e0242ac110002.jpg',
        price:7400,
        name:'Old Maple Farm',
        address:'10, Mehrauli, Delhi',
        beds:2,
        bathrooms:1,
        area:'7 x 5 sq. m',
        wishlist:false,
        popular:true,
        date:4,
        month:8,
        year:2022,
        location:'Delhi',
        type:'Ranch',
    },
    {
        id:7,
        imgURL:'https://assets.architecturaldigest.in/photos/60dc14360e8686d95b6979f1/master/pass/Pune-Stud-farm-AM-PM-design-photos.jpg',
        price:6500,
        name:'Nirvana',
        address:'10, Mehrauli, Varanasi',
        beds:2,
        bathrooms:2,
        area:'7 x 8 sq. m',
        wishlist:true,
        popular:false,
        date:9,
        month:9,
        year:2022,
        location:'Varanasi',
        type:'Apartment',
    },
    {
        id:8,
        imgURL:'https://img.staticmb.com/mbimages/project/Photo_h310_w462/2019/06/04/Project-Photo-15-Vinayak-Platina-Varanasi-5073860_600_1000_310_462.jpg',
        price:13800,
        name:'Sitara Flats',
        address:'10, Mehrauli, Varanasi',
        beds:4,
        bathrooms:2,
        area:'9 x 9 sq. m',
        wishlist:false,
        popular:true,
        date:5,
        month:9,
        year:2022,
        location:'Varanasi',
        type:'Flat',
    },
    {
        id:9,
        imgURL:'https://www.revv.co.in/blogs/wp-content/uploads/2021/07/Hilton-shilim-Pune-1280x720.png',
        price:3700,
        name:'Greenway Courts',
        address:'10, Mehrauli, Varanasi',
        beds:1,
        bathrooms:1,
        area:'7 x 6 sq. m',
        wishlist:true,
        popular:false,
        date:5,
        month:9,
        year:2022,
        location:'Varanasi',
        type:'Ranch',
    },
    {
        id:10,
        imgURL:'https://s3-assets.propstory.com/news-and-opinions/wp-content/uploads/2015/09/a-JUBILEE-HILLS-HOUSE-640x468.jpg',
        price:5600,
        name:'Manokamna',
        address:'10, Mehrauli, Mumbai',
        beds:1,
        bathrooms:1,
        area:'7 x 6 sq. m',
        wishlist:true,
        popular:true,
        date:5,
        month:9,
        year:2022,
        location:'Mumbai',
        type:'Apartment',
    },
    {
        id:11,
        imgURL:'https://s3-assets.propstory.com/news-and-opinions/wp-content/uploads/2015/09/a-JUBILEE-HILLS-HOUSE-640x468.jpg',
        price:10600,
        name:'Manokamna',
        address:'10, Mehrauli, Mumbai',
        beds:1,
        bathrooms:1,
        area:'7 x 6 sq. m',
        wishlist:true,
        popular:true,
        date:5,
        month:9,
        year:2022,
        location:'Mumbai',
        type:'Apartment',
    },
    {
        id:12,
        imgURL:'https://mldllifespacebucket01.s3.amazonaws.com/2018/11/boisar-overview.jpg',
        price:2800,
        name:'Ray White',
        address:'10, Mehrauli, Mumbai',
        beds:2,
        bathrooms:1,
        area:'9 x 8 sq. m',
        wishlist:false,
        popular:false,
        date:5,
        month:9,
        year:2022,
        location:'Mumbai',
        type:'Flat',
    },
    {
        id:13,
        imgURL:'https://mldllifespacebucket01.s3.amazonaws.com/2018/11/boisar-overview.jpg',
        price:11800,
        name:'Ray White',
        address:'10, Mehrauli, Mumbai',
        beds:2,
        bathrooms:1,
        area:'9 x 8 sq. m',
        wishlist:false,
        popular:false,
        date:5,
        month:9,
        year:2022,
        location:'Mumbai',
        type:'Flat',
    },
    {
        id:14,
        imgURL:'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8cHJvcGVydHl8ZW58MHx8MHx8&auto=format&fit=crop&w=600&q=60',
        price:2400,
        name:'Oak Wood',
        address:'10, Mehrauli, Mumbai',
        beds:3,
        bathrooms:2,
        area:'7 x 7 sq. m',
        wishlist:false,
        popular:false,
        date:5,
        month:9,
        year:2022,
        location:'Mumbai',
        type:'Ranch',
    },
    {
        id:15,
        imgURL:'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8cHJvcGVydHl8ZW58MHx8MHx8&auto=format&fit=crop&w=600&q=60',
        price:7400,
        name:'Oak Wood',
        address:'10, Mehrauli, Mumbai',
        beds:3,
        bathrooms:2,
        area:'7 x 7 sq. m',
        wishlist:false,
        popular:false,
        date:6,
        month:9,
        year:2022,
        location:'Mumbai',
        type:'Ranch',
    },
    {
        id:16,
        imgURL:'https://assets.architecturaldigest.in/photos/6008391a94ca758bb0ad102d/4:3/w_1024,h_768,c_limit/white-house-shroffleon-mumbai-featured-image-1366x768.jpg',
        price:1300,
        name:'Royal View',
        address:'10, Mehrauli, Delhi',
        beds:2,
        bathrooms:2,
        area:'8 x 8 sq. m',
        wishlist:false,
        popular:false,
        date:5,
        month:9,
        year:2022,
        location:'Delhi',
        type:'Apartment',
    },
    {
        id:17,
        imgURL:'https://assets.architecturaldigest.in/photos/6008391a94ca758bb0ad102d/4:3/w_1024,h_768,c_limit/white-house-shroffleon-mumbai-featured-image-1366x768.jpg',
        price:8300,
        name:'Royal View',
        address:'10, Mehrauli, Delhi',
        beds:2,
        bathrooms:2,
        area:'8 x 8 sq. m',
        wishlist:false,
        popular:false,
        date:5,
        month:9,
        year:2022,
        location:'Delhi',
        type:'Apartment',
    },
    {
        id:18,
        imgURL:'https://teja10.kuikr.com/i6/20220928/1-BHK-420-Sq-ft-Apartment-for-Sale-in-Kalyan-West--Mumbai-ak_LWBP391155191-1664346589_gv.jpeg',
        price:12300,
        name:'Sunset Treasury',
        address:'10, Mehrauli, Delhi',
        beds:1,
        bathrooms:1,
        area:'5 x 6 sq. m',
        wishlist:true,
        popular:false,
        date:5,
        month:9,
        year:2022,
        location:'Delhi',
        type:'Flat',
    },
    {
        id:19,
        imgURL:'https://teja10.kuikr.com/i6/20220928/1-BHK-420-Sq-ft-Apartment-for-Sale-in-Kalyan-West--Mumbai-ak_LWBP391155191-1664346589_gv.jpeg',
        price:6300,
        name:'Sunset Treasury',
        address:'10, Mehrauli, Delhi',
        beds:1,
        bathrooms:1,
        area:'5 x 6 sq. m',
        wishlist:true,
        popular:false,
        date:5,
        month:9,
        year:2022,
        location:'Delhi',
        type:'Flat',
    },
    {
        id:20,
        imgURL:'https://gos3.ibcdn.com/e800fba692e511eba30e0242ac110002.jpg',
        price:3400,
        name:'Old Maple Farm',
        address:'10, Mehrauli, Delhi',
        beds:2,
        bathrooms:1,
        area:'7 x 5 sq. m',
        wishlist:false,
        popular:true,
        date:5,
        month:5,
        year:2022,
        location:'Delhi',
        type:'Ranch',
    },
    {
        id:21,
        imgURL:'https://gos3.ibcdn.com/e800fba692e511eba30e0242ac110002.jpg',
        price:14400,
        name:'Old Maple Farm',
        address:'10, Mehrauli, Delhi',
        beds:2,
        bathrooms:1,
        area:'7 x 5 sq. m',
        wishlist:false,
        popular:true,
        date:5,
        month:9,
        year:2022,
        location:'Delhi',
        type:'Ranch',
    },
    {
        id:22,
        imgURL:'https://assets.architecturaldigest.in/photos/60dc14360e8686d95b6979f1/master/pass/Pune-Stud-farm-AM-PM-design-photos.jpg',
        price:1500,
        name:'Nirvana',
        address:'10, Mehrauli, Varanasi',
        beds:2,
        bathrooms:2,
        area:'7 x 8 sq. m',
        wishlist:true,
        popular:false,
        date:6,
        month:9,
        year:2022,
        location:'Varanasi',
        type:'Apartment',
    },
    {
        id:23,
        imgURL:'https://assets.architecturaldigest.in/photos/60dc14360e8686d95b6979f1/master/pass/Pune-Stud-farm-AM-PM-design-photos.jpg',
        price:13500,
        name:'Nirvana',
        address:'10, Mehrauli, Varanasi',
        beds:2,
        bathrooms:2,
        area:'7 x 8 sq. m',
        wishlist:true,
        popular:false,
        date:5,
        month:9,
        year:2022,
        location:'Varanasi',
        type:'Apartment',
    },
    {
        id:24,
        imgURL:'https://img.staticmb.com/mbimages/project/Photo_h310_w462/2019/06/04/Project-Photo-15-Vinayak-Platina-Varanasi-5073860_600_1000_310_462.jpg',
        price:5800,
        name:'Sitara Flats',
        address:'10, Mehrauli, Varanasi',
        beds:4,
        bathrooms:2,
        area:'9 x 9 sq. m',
        wishlist:false,
        popular:true,
        date:10,
        month:9,
        year:2022,
        location:'Varanasi',
        type:'Flat',
    },
    {
        id:25,
        imgURL:'https://img.staticmb.com/mbimages/project/Photo_h310_w462/2019/06/04/Project-Photo-15-Vinayak-Platina-Varanasi-5073860_600_1000_310_462.jpg',
        price:3800,
        name:'Sitara Flats',
        address:'10, Mehrauli, Varanasi',
        beds:4,
        bathrooms:2,
        area:'9 x 9 sq. m',
        wishlist:false,
        popular:true,
        date:5,
        month:9,
        year:2022,
        location:'Varanasi',
        type:'Flat',
    },
    {
        id:26,
        imgURL:'https://www.revv.co.in/blogs/wp-content/uploads/2021/07/Hilton-shilim-Pune-1280x720.png',
        price:13700,
        name:'Greenway Courts',
        address:'10, Mehrauli, Varanasi',
        beds:1,
        bathrooms:1,
        area:'7 x 6 sq. m',
        wishlist:true,
        popular:false,
        date:5,
        month:9,
        year:2022,
        location:'Varanasi',
        type:'Ranch',
    },
    {
        id:27,
        imgURL:'https://www.revv.co.in/blogs/wp-content/uploads/2021/07/Hilton-shilim-Pune-1280x720.png',
        price:7700,
        name:'Greenway Courts',
        address:'10, Mehrauli, Varanasi',
        beds:1,
        bathrooms:1,
        area:'7 x 6 sq. m',
        wishlist:true,
        popular:false,
        date:5,
        month:9,
        year:2022,
        location:'Varanasi',
        type:'Ranch',
    },
]